import ChartLegend from "./ChartLegend";
import ChartWrapper from "./ChartWrapper";
import ChartSet from "./ChartSet";

import AxisLabel from "./charts/AxisLabel";

import AsterChart from "./charts/AsterChart";
import ColumnChart from "./charts/ColumnChart";
import LineChart from "./charts/LineChart";
import SankeyChart from "./charts/SankeyChart";
import ScatterChart from "./charts/ScatterChart";

export {
  AsterChart,
  ColumnChart,
  LineChart,
  SankeyChart,
  ScatterChart,
  AxisLabel,
  ChartLegend,
  ChartSet,
  ChartWrapper,
};

export default {
  AsterChart,
  ColumnChart,
  LineChart,
  SankeyChart,
  ScatterChart,

  AxisLabel,
  ChartLegend,
  ChartSet,
  ChartWrapper,
};
